<lgb-header-gradient [height]="((isReady())? 200 : 100)" [background]="!isReady()"></lgb-header-gradient>
<div class="screen-container gradient" [loading]="loading()">
	@if(isReady()){
		<div class="hero-card rounded-box">
			<img wSkeleton="100%" hSkeleton="500px" class="img-card" [altImg]="cardS.getImages(card().img)"/>
			<div class="card-container">
				<!-- favoris -->
				<div class="fav-container">
					@if(!backTo()){
						<a [routerLink]="this.router.get('card-search')" class="back add-fav glass rounded-full bg-black/40">
							<i class="fa-regular fa-chevron-left"></i>
						</a>
					}
					@else{
						<a (click)="goTo()" class="back add-fav glass rounded-full bg-black/40">
							<i class="fa-regular fa-chevron-left"></i>
						</a>
					}
				</div>
			</div>
		</div>

		<!-- extension -->
		<img class="img-card-set mb-4" [altImg]="cardS.getLogos(cardSet().logo, true)"/>
		<div class="ext-container">
			<p class="title-sticky title-xs font-serra name-card">{{name()?.text}}</p>
			<div class="summary-item">
				<!-- numéro -->
				<div class="mt-2">
					<i class="badge badge-soft badge-primary fa-regular fa-hashtag mr-2"></i> {{card().numero}}
				</div>

				<!-- rareté -->
				<div class="mt-2">
					<i class="badge badge-soft badge-primary fa-regular fa-stars ml-6 mr-2"></i> {{getRarity().name}}
				</div>

				<!-- date de sortie de la carte = extension -->
				<div class="mt-2">
					<i class="badge badge-soft badge-primary fa-light fa-calendar-days ml-6 mr-2"></i> {{cardSet().releaseDate | date:'dd/MM/yyyy'}}
				</div>
			</div>
		</div>

		<p class="title-sticky title-xs font-serra mt-4 mb-2">Estimation de la carte</p>
		<lgb-prices-grid [prices]="prices()"></lgb-prices-grid>

		<p class="title-sticky title-xs font-serra mt">Dans la collection</p>
		<ul 
			class="list bg-base-100 rounded-box shadow-md mb-4"
			#searchable="searchable"
			[qSearch]="null"
			[search]="search()"
			[(results)]="inventoryPage"
			[length]="length">

		  @if(inventory().length){
	  	  	<li class="p-4 pb-2 opacity-60 tracking-wide">Liste des exemplaires de cette carte</li>		  	
		  }
		  @else{
	  	  	<li class="p-4 pb-2 opacity-60 tracking-wide">Aucun exemplaire de cette carte</li>		  	
		  }
		  @for(cardBinder of inventoryPage(); track cardBinder.ident){
			  <li class="list-row">
			    <div>
			    	<img class="size-10" [src]="binderS.getImgInventory(cardBinder.img)"/>
			    </div>
			    <div>
			      <div class="capitalize">{{cardBinder.lang}} - {{getCondition(cardBinder.condition).name}}</div>
			      <div class="text-xs capitalize font-semibold opacity-60">
			      	@if(cardBinder.binder){
			      		Binder #{{cardBinder.binder}}
			      	}
			      	@else{
			      		Binder sans code
			      	}
			      </div>
			    </div>
			    <a href="#" [routerLink]="router.parse('collect-card', [cardBinder.ident])" [queryParams]="{backTo: router.parse('card-index', [card().ident])}" class="btn btn-square btn-ghost text-primary">
					<i class="fa-light fa-eyes"></i>
					<!-- <i class="fa-regular fa-arrow-right-from-bracket"></i> -->
			    </a>
			  </li>
		  }
		</ul>
		@if(inventory().length){
			<div class="pagination mt-4">
				<div class="join">
				  @if(searchable.canPrev()){
			  	  	<button (click)="searchable.prev()" class="join-item btn">«</button>
			  	  }
				  <button class="join-item btn">Page {{searchable.page()+1}}</button>
				  @if((searchable.page()+1)*length < inventory().length){
				  	<button (click)="searchable.next()" class="join-item btn">»</button>
				  }
				</div>
			</div>
		}
	}
</div>